import { combineReducers } from 'redux';
import Immutable from 'immutable';

import post from './post';
import profile from './profile';
import wheel from './wheel';
import entities from './entities';
import modal from './modal';
import device from './device';
import portal from './portal';
import membership from './membership';
import referer from './referer';

const initialState = Immutable.Map();

function phase(state = 0, action) {
  return state;
};

function appdata(state = 0, action) {
  return state;
};

function error(state = initialState, action) {
  return state;
};

function cookie(state = {}, action) {
  return state;
};

export default combineReducers({
  entities,
  modal,
  post,
  profile,
  portal,
  membership,
  wheel,
  device,
  phase,
  appdata,
  error,
  cookie,
  referer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js